import React, { createContext, useState, useEffect, useReducer } from 'react';
import CONQUER from '../../Conquer/CONQUER';

export const ConquerContext = createContext();

const ConquerContextProvider = (props) => {
    const [conquerInstance, setConquerInstance] = useState( false );

    function loadConquer() {
        async function asyncLoad() {

            let conquer = new CONQUER();
            await conquer.init();
            setConquerInstance( conquer );

        }

        asyncLoad();
    }
    useEffect(loadConquer, []);

    return (
        <ConquerContext.Provider value={conquerInstance}>
            {props.children}
        </ConquerContext.Provider>
    );
};
export default ConquerContextProvider;
